import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router-dom'

// CSS
import './Sidebar.css'

class Sidebar extends Component {

    static propTypes = {
        news: PropTypes.array.isRequired
    }

    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-content">
                    <h3>News</h3>
                    <ul>
                        {this.props.news.map(news => {
                            return (
                                <li key={news.url}>
                                    <Link to={'/news/' + news.url} key={news.url}>
                                        <span className="news-title">{news.title} - {moment(news.posted).format('DD-MM-YYYY')}</span>
                                    </Link>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )

    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/sidebar/Sidebar.js